import { FileViewer, type FileSource } from '@powerportalspro/react-fluent';

const markdownText = `# Hello FileViewer

The **FileViewer** picks a renderer per file kind.

- Images flow through \`ImageViewer\`.
- Markdown picks up a markdown parser.
- Text/code is coloured with highlight.js.
- Zip archives expand to a tree.

\`\`\`ts
const source: FileSource = { kind: 'bytes', bytes, fileName: 'readme.md' };
\`\`\`
`;

const source: FileSource = {
  kind: 'bytes',
  value: new TextEncoder().encode(markdownText),
  fileName: 'readme.md',
};

export function FileViewerMarkdownSample() {
  return <FileViewer source={source} fileName="readme.md" maxHeight="320px" />;
}
